import React, { useRef } from "react";
import "./TeamSlider.css";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore from "swiper/core";
import "swiper/swiper-bundle.css";
import { Box, Typography } from "@mui/material";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import ImageBottomBanner from "../../assets/images/ImageflowerBanner.png";
import LeftArrow from "../../assets/icons/LeftArrowImage.png";
import RightArrow from "../../assets/icons/RightArrowImage.png";
import TeamImage from "../../assets/images/TeamImage.png";
import { teamData } from "../../data/team";
import TeamMemberPopup from '../Popup/TeamMemberPopup';

SwiperCore.use([Navigation]);

function TeamSlider() {
  const swiperRef = useRef(null);
  const [selectedMember, setSelectedMember] = React.useState(null);

  const goPrev = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev();
    }
  };

  const goNext = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext();
    }
  };

  return (
    <Box
      sx={{
        maxWidth: { xs: "100%", sm: "1440px" },
        margin: "0 auto",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box>
        <button className="custom-prev-button portfolio-btn-btn" onClick={goPrev}>
          <Box sx={{ width: "3rem" }}>
            <img src={LeftArrow} alt="" width="100%" />
          </Box>
        </button>
      </Box>

      <Box
        sx={{
          width: { xs: "95%", sm: "88%" },
          height: { xs: "16rem", sm: "20rem" },
          position: "relative",
          marginTop: "5rem",
        }}
      >
        <Box sx={{ width: "100%", height: "100%" }}></Box>
        <div className="team-crousel">
          <div className="swiper-main">
            <Swiper
              ref={swiperRef}
              spaceBetween={20}
              slidesPerView={3}
              centeredSlides={true}
              initialSlide={1}
              navigation={{
                nextEl: ".custom-next-button",
                prevEl: ".custom-prev-button",
              }}
              breakpoints={{
                0: {
                  slidesPerView: 2.25,
                  loop: false,
                  centeredSlides: false,
                  initialSlide: 0,
                },
                740: {
                  slidesPerView: 2.3,
                  loop: false,
                  centeredSlides: false,
                  initialSlide: 0,
                },
                1024: {
                  slidesPerView: 3,
                  loop: true,
                  centeredSlides: true,
                  initialSlide: 1,
                },
              }}
              onSwiper={(swiper) => console.log(swiper)}
              onSlideChange={() => console.log("slide change")}
            >
              {teamData.map((member, index) => (
                <SwiperSlide 
                  key={index}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <Box
                    onClick={() => setSelectedMember(member)}
                    sx={{
                      cursor: 'pointer',
                      '&:hover': {
                        transform: 'scale(1.02)',
                        transition: 'transform 0.2s ease-in-out',
                      },
                      width: { xs: "9rem", sm: "16rem" },
                      height: { xs: "12rem", sm: "20rem" },
                      borderRadius: "1rem",
                      overflow: "hidden",
                      margin: "0 auto",
                    }}
                  >
                    <Box
                      sx={{
                        position: "relative",
                        borderRadius: "1rem",
                        width: "100%",
                        height: "100%",
                      }}
                    >
                      <img
                        src={member.Image}
                        alt={member.Name}
                        style={{ width: "100%", borderRadius: "1rem" }}
                      />

                      {/* Box for Heading and Description */}
                      <Box
                        sx={{
                          position: "absolute",
                          top: "88%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          zIndex: 2,
                          color: "#fff",
                          textAlign: "center",
                          width: "100%",
                        }}
                      >
                        <Typography
                          variant="h6"
                          sx={{
                            fontSize: { xs: "0.9rem", sm: "1.2rem" },
                            fontWeight: "400",
                          }}
                        >
                          {member.Name}
                        </Typography>
                        <Typography
                          sx={{
                            mt: 0.2,
                            fontFamily: "Plus Jakarta Sans",
                            fontSize: { xs: "0.6rem", sm: "0.8rem" },
                            textDecoration: "underline"
                          }}
                        >
                          Know More
                        </Typography>
                        {/* <Typography
                          sx={{
                            mt: 0.2,
                            fontFamily: "Plus Jakarta Sans",
                            fontSize: { xs: "0.6rem", sm: "0.8rem" },
                          }}
                        >
                          Head Director
                        </Typography> */}
                      </Box>

                      {/* ImageBottomBanner */}
                      <Box
                        sx={{
                          zIndex: 1,
                          position: "absolute",
                          top: "70%",
                          width: { xs: "9rem", sm: "16rem" },
                        }}
                      >
                        <img src={ImageBottomBanner} alt="" width="100%" />
                      </Box>
                    </Box>
                  </Box>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </Box>

      <Box>
        <button className="custom-next-button portfolio-btn-btn" onClick={goNext}>
          <Box sx={{ width: "3rem" }}>
            <img src={RightArrow} alt="" width="100%" />
          </Box>
        </button>
      </Box>

      <TeamMemberPopup 
        member={selectedMember} 
        onClose={() => setSelectedMember(null)} 
      />
    </Box>
  );
}

export default TeamSlider;
